import { render, staticRenderFns } from "./JLprojectTable.vue?vue&type=template&id=177e3aa8&scoped=true"
import script from "./JLprojectTable.vue?vue&type=script&lang=js"
export * from "./JLprojectTable.vue?vue&type=script&lang=js"
import style0 from "./JLprojectTable.vue?vue&type=style&index=0&id=177e3aa8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "177e3aa8",
  null
  
)

export default component.exports